<!-- Main container -->
<div class="layout-col full">
  <!-- Search Component -->

  <elder-table
    class="flex"
    matSort
    [data]="data"
    [idField]="'number'"
    (itemClick)="openSideDetail($event)"
  >
    <elder-data-toolbar
      *elderTableToolbar
      (requestNew)="create()"
      [canRemove]="false"
      [canAdd]="canAdd"
      [canMore]="false"
    >
      <ng-template elderToolbarContent="center">
        <elder-search-box
          dense
          class="flex-60 pt-xs"
          queryKey="query"
          [autoPanel]="false"
          [elderSearchContext]="data.filter"
          [forcedFilters]="forcedFilters$ | async"
        >
          <!-- Advanced search -->
          <elder-search-panel class="layout-col p-sm">
            <div class="layout-row place-start-center gap-sm">
              <mat-slide-toggle elderSearchInput name="archived" ngModel>
                {{ 'context.archived' | translate }}
              </mat-slide-toggle>
            </div>
          </elder-search-panel>
        </elder-search-box>
      </ng-template>
    </elder-data-toolbar>

    <!-- icon -->
    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef style="width: 30px"></th>
      <td mat-cell *matCellDef="let row">
        <mat-icon>work</mat-icon>
      </td>
    </ng-container>

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let wc">{{ wc.number }}</td>
    </ng-container>

    <!-- name Column -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let wc">{{ wc.name }}</td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let wc">
        <div class="layout-col place-center-start">
          <span class="mat-body-2">{{ wc.description }}</span>
        </div>
      </td>
    </ng-container>

    <!-- workstations Column -->
    <ng-container matColumnDef="workstations">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'shopfloor.workstations.title' | translate }}
      </th>
      <td mat-cell *matCellDef="let wc">
        <app-work-stations-indicator [workStationIds]="wc.workStations">
        </app-work-stations-indicator>
      </td>
    </ng-container>

    <!-- facility Column -->
    <ng-container matColumnDef="facility">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'context.facility' | translate }}
      </th>
      <td mat-cell *matCellDef="let wc">{{ wc.company }} / {{ wc.facility }}</td>
    </ng-container>

    <!-- assignment strategy Column -->
    <ng-container matColumnDef="strategy">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'shopfloor.workcenters.assignmentStrategies.assignmentStrategy' | translate }}
      </th>
      <td mat-cell *matCellDef="let wc">
        {{ 'shopfloor.workcenters.assignmentStrategies.' + wc.assignmentStrategy | translate }}
      </td>
    </ng-container>

    <!-- createdAt -->
    <ng-container matColumnDef="createdAt">
      <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header>
        {{ 'context.createdAt' | translate }}
      </th>
      <td mat-cell *matCellDef="let wc">
        {{ wc.audit.createdAt | date: 'short' }}
      </td>
    </ng-container>
  </elder-table>
</div>
